import { useBreakpointValue } from "@chakra-ui/react"

// True below the lg breakpoint (62em), where the sidebar becomes a top bar: the screens on which
// lists are shown as cards and toolbar buttons as icons. Read synchronously (ssr: false) so the
// first render already uses the right variant.
export const useIsCompactScreen = (): boolean =>
  useBreakpointValue({ base: true, lg: false }, { ssr: false }) ?? true
